import './gtm';
import * as gtm from './gtm_trigger';

Object.entries(gtm).forEach(([name, func]) => {
	window[name] = func;
});
